<!--
 * @Author: your name
 * @Date: 2022-03-17 16:41:37
 * @LastEditTime: 2022-03-23 12:39:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\Login.vue
-->
<template>
  <div>
    <div class="Login-all">
      <div class="Login-w">
        <div class="login-header">
          <p>{{ $t("Login.Community") }}</p>
        </div>
        <div class="login-header-center">
          <p>{{ $t("Login.what") }}</p>
        </div>
        <div class="login-header-button">
          <p>
            {{ $t("Login.Were") }}
          </p>
        </div>
        <div class="login-Imgs clearfix">
          <div class="login-Imgs-lfet">
            <img src="../../../assets/pc/mbg.png" alt="" />
          </div>
          <div class="login-Imgs-right">
            <div class="clearfix">
              <div class="login-Imgs-right-images">
                <img src="../../../assets/pc/intro/头像.png" alt="" />
              </div>
              <div class="login-Imgs-right-text">
                <p class="login-Imgs-right-p1">{{ $t("Login.Forget") }}</p>
                <p class="login-Imgs-right-p2">{{ $t("Login.Welcome") }}</p>
              </div>
            </div>
            <el-form
              ref="ruleForm"
              :model="ruleForm"
              :rules="rules"
              label-width="100px"
              class="demo-ruleForm"
              autocomplete="off"
            >
              <div v-if="active == 1">
                <!-- 邮箱 -->
                <el-form-item prop="email">
                  <el-input v-model="ruleForm.email" placeholder="Email" />
                  <el-button
                    @click="sendMsg"
                    class="el-btn1"
                    >{{ $t("Register.Sendcode") }}</el-button
                  >
                  <span class="status">{{ statusMsg }}</span>
                </el-form-item>
                <!-- 验证码 -->
                <el-form-item prop="code">
                  <el-input
                    v-model="ruleForm.code"
                    maxlength="6"
                    placeholder="Verification Code"
                  />
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="pwd">
                  <el-input
                    v-model="ruleForm.pwd"
                    type="password"
                    placeholder="Password"
                  />
                </el-form-item>
                <!-- 确认密码 -->
                <el-form-item prop="cpwd">
                  <el-input
                    v-model="ruleForm.cpwd"
                    type="password"
                    placeholder="Confirm password"
                  />
                </el-form-item>
                <!-- 提交注册 -->
                <el-form-item prop="Signup">
                  <el-button
                    @click="Forgot"
                    class="el-btn2"
                    >OK</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetEmail,UpdatePwd } from "@/assets/server/api.js";
export default {
  data() {
    return {
      active: 1,
      statusMsg: "",
      ruleForm: {
        code: "",
        pwd: "",
        cpwd: "",
        email: "",
      },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            message: "Please input email",
            trigger: "blur",
          },
        ],
        pwd: [
          {
            required: true,
            message: "Create password",
            trigger: "blur",
          },
        ],
        cpwd: [
          {
            required: true,
            message: "Confirm password",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please input the password again"));
              } else if (value !== this.ruleForm.pwd) {
                callback(new Error("The two passwords are inconsistent"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      formData: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      reg: "reg",
      email:"",
    };
  },
  layout: "blank",

  methods: {
    // 获取验证码
    async sendMsg() {
      let formData = new FormData();
      let params = {
        email: this.ruleForm.email,
        tp: this.reg,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetEmail(formData);
      console.log(data);
      const self = this;
      let namePass;
      let emailPass;
      if (self.timerid) {
        return false;
      }
      // this.$refs["ruleForm"].validateField("name", (valid) => {
      //   namePass = valid;
      // });
      self.statusMsg = "";
      if (namePass) {
        return false;
      }
      this.$refs["ruleForm"].validateField("email", (valid) => {
        emailPass = valid;
      });
    },
    // 忘记密码
    async Forgot(){
        // 获取邮箱
        let email = this.ruleForm.email;
        // 获取密码
        let password = this.ruleForm.pwd;
        // 获取验证码
        let code = this.ruleForm.code;
        // 获取确认密码
        let cpwd = this.ruleForm.cpwd;
        let params = {
            email:email,
            password:password,
            code:code
        }
        if(password === cpwd){
            let data = await UpdatePwd(params);
           if(data.code == 0){
             this.$message.success( data.msg);
             localStorage.setItem("email",email);
             this.$router.push('/pc/Login');
           }else{
             this.$message.error(data.msg);
           }
        }else{
          this.$message.error("Inconsistent passwords");
        }
    }
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.Login-all {
  width: 100%;
  height: 100%;
  background: url(../../../assets/pc/intro/back.png) no-repeat center / 100%
    100%;
  .Login-w {
    width: 1200px;
    margin: 0 auto;
    padding: 159px 0 0 10px;
    .login-header {
      font-size: 80px;
      font-weight: 900;
      font-family: Poppins-Black, Poppins;
      color: #000;
      line-height: 103px;
      -webkit-background-clip: text;
      margin-bottom: 45px;
    }
    .login-header-center {
      font-weight: 500;
      font-size: 24px;
      color: #000;
      line-height: 28px;
      margin-bottom: 22px;
      -webkit-background-clip: text;
      font-family: Poppins-Medium, Poppins;
    }
    .login-header-button {
      font-size: 18px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #61666b;
      line-height: 30px;
      -webkit-background-clip: text;
      margin-bottom: 90px;
    }
    .login-Imgs {
      margin-bottom: 331px;
      box-shadow: 0 4px 30px 1px rgba(0, 0, 0, 0.06);
      .login-Imgs-lfet {
        img {
          width: 780px;
          height: 614px;
          float: left;
        }
      }
      .login-Imgs-right {
        float: left;
        width: 410px;
        height: 614px;
        background-color: #fff;

        padding: 53px 30px 0 30px;
        box-sizing: border-box;
        .login-Imgs-right-images {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #e3eafb;
          float: left;
          margin-right: 25px;
        }
        .login-Imgs-right-text {
          float: left;
          .login-Imgs-right-p1 {
            font-size: 24px;
            font-weight: 600;
            color: #2c1d1a;
            line-height: 41px;
            font-family: Poppins-SemiBold, Poppins;
            -webkit-background-clip: text;
            margin: 0;
          }
          .login-Imgs-right-p2 {
            font-size: 14px;
            font-weight: 400;
            color: #2c1d1a;
            line-height: 24px;
            -webkit-background-clip: text;
            font-family: Poppins-Regular, Poppins;
          }
        }
        .login-input {
          input {
            width: 340px;
            height: 40px;
            background: #ffffff;
            opacity: 1;
            border: 2px solid #4573e7;
            display: inline-block;
            font-size: 14px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #bfc1cc;
            line-height: 16px;
            padding: 0 0 0 8px;
            -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
          }
          .login-input1 {
            margin-top: 50px;
          }

          .login-input2 {
            margin: 25px 0;
          }
        }
        .login-input3 {
          span {
            display: inline-block;
            float: left;
            input {
              width: 245px;
              height: 40px;
              background: #ffffff;
              opacity: 1;
              border: 1px solid #c5d0de;
              font-size: 14px;
              font-family: Poppins-Regular, Poppins;
              font-weight: 400;
              color: #bfc1cc;
              line-height: 16px;
              -webkit-background-clip: text;
              padding: 0 0 0 8px;
            }
          }
          span:nth-child(2) {
            width: 85px;
            height: 40px;
            // border-radius: 0px 0px 0px 0px;
            opacity: 1;
            background-color: #000;
            margin: 1px 0 0 10px;
          }
        }
        .Login-btn-buttom {
          p {
            font-size: 14px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #4573e7;
            line-height: 24px;
            -webkit-background-clip: text;
          }
          div:nth-child(1) {
            float: left;
          }
          div:nth-child(2) {
            float: right;
          }
        }
      }
      .el-form-item /deep/ .el-form-item__content {
        margin: 0 !important;
      }
      .el-form-item:nth-child(1) {
        margin: 50px 0 25px 0;
      }
      .el-form-item:nth-child(3) {
        margin: 25px 0;
      }
      .el-form-item:nth-child(5) {
        margin: 25px 0 0 0;
      }
      .el-form-item {
        position: relative !important;
      }
      .el-btn1 {
        width: 75px !important;
        height: 23px !important;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #4573e7 !important;
        border-radius: 0;
        background-color: #fff !important;
        border: none;
        border-left: 1px solid #c5d0de;
        font-size: 14px;
        position: absolute;
        top: 9px;
        right: 23px;
        opacity: 1;
        padding: 0 15px;
      }
      .el-btn2 {
        width: 350px;
        height: 40px;
        background: #4573e7;
        border-radius: 5px;
        opacity: 1;
        border: 1px solid #c5d0de;
        /*margin-top: 25px;*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
}
</style>
